export default class MessageDictionary {
  static lang = { 'en-US' : { color: 'color', favorite: 'favorite' } 
         , 'en-CA' : { color: 'colour', favorite: 'favourite' } };

  static translate( l, word)
  {
    return ( ( MessageDictionary.lang[l] !== undefined ) && (MessageDictionary.lang[l][word] !== undefined ) ) ? MessageDictionary.lang[l][word] : word ;
  }
}